import React, { useMemo } from "react";
import dynamic from "next/dynamic";
import type { PieConfig } from "@ant-design/plots";
import type { IDiversityAum2 } from "@/models/etfs";
import { formatPercent } from "@/helpers";

const Pie = dynamic(() => import("@ant-design/plots").then(mod => mod.Pie), {
  ssr: false,
});

interface PieChartProps {
  data?: IDiversityAum2[];
  isLoading?: boolean;
}

const PieChart: React.FC<PieChartProps> = ({ data, isLoading }) => {
  const chartData = useMemo(() => data?.map(item => ({ type: item.ticker, value: item.percentage })) ?? [], [data]);

  const config: PieConfig = useMemo(
    () => ({
      appendPadding: 10,
      data: chartData,
      angleField: "value",
      colorField: "type",
      radius: 1,
      label: {
        type: "inner",
        content: data => (data.percent > 0.09 ? `${data.type}\n${formatPercent(data.percent * 100)}%` : ""),
        offset: "-50%",
        style: {
          fontSize: 14,
          fill: "black",
          textAlign: "center",
        },
        autoRotate: false,
      },
      interactions: [{ type: "element-active" }],
      tooltip: {
        showMarkers: false,
        fields: ["type", "value"],
        formatter: datum => ({
          name: datum.type,
          value: `${datum.value}%`,
        }),
      },
      legend: {
        position: "bottom",
      },
    }),
    [chartData],
  );

  return <Pie {...config} loading={isLoading} />;
};

export default PieChart;
